export default {
  namespaced: true,
  state: {
    messages: [],
  },
  mutations: {
    message(state, messages = []) {
      state.messages = [].concat(messages)
    },
  },
}
